<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        Mail ({{ parentDataCopy.isCc ? 'Cc:' :'To:' }}) - Workflow Template
        <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content>
    <div class="row m-0">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' TextField="group_Name"  ValueField="group_Id" WaterMarkText="Business Group" [dataSource]='businessGroupList' setId="ddDiscpId" (valueChange)='changeBusinessGroup($event)' [clearValue]='businessGroupClearFlag' [IsCascading]='true' [defaultValue]='previousBusinessGroupId'>
            </EIPAutoComplete>
        </div>
    </div>
    <div class="nav-container-1 m-0">
        <div class="row reset-row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 tab-container">
                <mat-tab-group>
                    <mat-tab label="{{'Member -' + this.memberSelectedList.length}}">
                        <EIPGeneralCart [CartParameters]="cartMemberRequest" (OnCartSubmit)='getSelectedMemberCartItems($event)' (OnClick)='setMemberCartParams()'>
                        </EIPGeneralCart>
                    </mat-tab>
                    <mat-tab label="{{'Role -' + this.roleSelectedList.length }}">
                        <EIPGeneralCart [CartParameters]="cartRoleRequest" (OnCartSubmit)='getSelectedRoleCartItems($event)' (OnClick)='setRoleCartParams()'>
                        </EIPGeneralCart>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <div class="row justify-content-end flex-grow-1">
        <button (click)="save()" class="btn btn-primary" type="submit"><i class="fa fa-save" aria-hidden="true" id="btnCopy" title="Save & Close"></i>&nbsp;&nbsp;Save & Close</button>
    </div>
</div>